// extracted by mini-css-extract-plugin
module.exports = {"viewport":"faczjY13ntjGiVvZYocX0Q=="};